<template>
    <!-- 学员列表 -->
    <div class="campus-list">
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-select v-model="params.condition.status" clearable placeholder="在读状态">
                    <el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.keyword" placeholder="姓名" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.nickname" placeholder="昵称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.telno" placeholder="联系方式" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.label" placeholder="标签" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div>
            <el-button type="primary" icon="el-icon-plus" v-if="!isSelect" @click="openAddStudent('')">新增学员</el-button>
            <el-button type="primary" v-if="isSelect" @click="deleteQuestion('')" :disabled="selection.length === 0">批量删除 ({{selection.length}})</el-button>
            <el-button type="primary" plain v-if="isSelect" @click="cancelDelete">取消批量删除</el-button>
        </div>
        <div class="mt-15">
            <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" @selection-change="handleSelectionChange" ref="table" :row-key="getRowKey">
                <el-table-column type="selection" v-if="isSelect" fixed key="selection" class-name="selection" align="right" :width="getTableHeaderWidthByCheckCol(isSelect)"></el-table-column>
                <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                    <template slot-scope="scope">
                        <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="昵称" align="center" min-width="175" key="nickname" fixed>
                    <template slot-scope="scope">
                        <p class="color-brand pointer" @click="goDetails(scope.row)">{{scope.row.nickname + `(${scope.row.studentno})`}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" align="center" width="150" key="name" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sexname" label="性别" align="center" width="100" key="sexname"></el-table-column>
                <el-table-column prop="campusname" label="所在校区" align="center" width="150" key="campusname" :formatter="formatTab"></el-table-column>
                <el-table-column prop="telno" label="联系方式" align="center" width="150" key="telno" :formatter="formatTab"></el-table-column>
                <el-table-column prop="periodcounton" label="入班数" align="center" width="100" key="periodcounton" :formatter="formatTab"></el-table-column>
                <el-table-column prop="totalscore" label="完成学分数" align="center" width="100" key="totalscore" :formatter="formatTab"></el-table-column>
                <el-table-column prop="statusname" label="在读状态" align="center" width="100" key="statusname" :formatter="formatTab"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="150" key="datetime" :formatter="formatTab"></el-table-column>
                <el-table-column prop="recenttclasstime" label="最近课时时间" align="center" width="150" key="recenttclasstime" :formatter="formatTab"></el-table-column>
                <el-table-column prop="recentlogintime" label="最近登录时间" align="center" width="150" key="recentlogintime" :formatter="formatTab"></el-table-column>
                <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton3()" key="edit" v-if="!isSelect">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sa ai-c">
                            <p class="pointer" v-if="scope.row.status === 10" @click="updateStudentStatus(scope.row, 11)">暂停</p>
                            <p class="color-text-sec" v-else>暂停</p>
                            <p class="pointer" v-if="scope.row.status === 11" @click="updateStudentStatus(scope.row, 10)">恢复</p>
                            <p v-else class="color-text-sec">恢复</p>
                            <p class="pointer" v-if="scope.row.status !== 100" @click="updateStudentStatus(scope.row, 100)">删除</p>
                            <p v-else class="color-text-sec">删除</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        </div>
        <AddStudent ref="AddStudent" @saveSuccess="saveSuccess"></AddStudent>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getStudentList,
  updateStudentStatus
} from '@/api/measApi/studentManage.js'
import AddStudent from './components/addStudent.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          classcode: '', // 班级code
          keyword: '', // 姓名昵称
          nickname: '',
          label: '', // 标签
          status: '', // 状态
          telno: '' // 联系方式
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      statusList: [
        {
          value: 9,
          label: '未读'
        },
        {
          value: 10,
          label: '在读'
        }
      ],
      isSelect: false,
      tableData: [],
      total: 0,
      selection: [],
      contentLoading: false
    }
  },
  components: {
    TableSort,
    Page,
    AddStudent
  },
  created() {
    this.getStudentList()
  },
  methods: {
    //   获取表格数据
    getStudentList() {
      this.contentLoading = true
      getStudentList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getStudentList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          classcode: '', // 班级code
          keyword: '', // 姓名昵称
          nickname: '',
          label: '', // 标签
          status: '', // 状态
          telno: '' // 联系方式
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getStudentList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getStudentList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getStudentList()
    },
    // 多选
    getRowKey(row) {
      return row.code
    },
    getdisabled(row) {
      return row.isedit
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 选择
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 取消批量删除
    cancelDelete() {
      this.isSelect = false
      this.$refs.table.clearSelection()
      this.selection = []
    },
    // 跳转到详情
    goDetails(row) {
      this.$router.push({
        name: 'StudentDetails',
        query: { code: row.code }
      })
    },
    // 打开新增编辑学员
    openAddStudent(code) {
      this.$refs.AddStudent.handleOpen(code)
    },
    // 保存成功
    saveSuccess() {
      this.params.page = 1
      this.getStudentList()
    },
    // 修改学员状态
    updateStudentStatus(row, args) {
      let text = ''
      if (args === 11) {
        text = '学员暂停之后将无法正常登录，继续吗？'
      } else if (args === 10) {
        text = '确定恢复该学员吗?'
      } else if (args === 100) {
        text = '学员删除之后将无法正常登录，继续吗？'
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          updateStudentStatus({
            codes: row.code,
            status: args,
            classcode: ''
          }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getStudentList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__empty-block {
  background: none;
}
</style>

